@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.order-details-nav-bar {
  background-color: var(--default--background-color--19);
  color: var(--default--text-color--18);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  padding: @space-12 @space-16;
  border: 1px solid var(--default--border-color--13);
  gap: @space-16;
}

.order-details-order-info-section {
  flex: 1;
  display: grid;
  grid-template: 'store-logo store-name order-number';
  grid-template-columns: 40px auto 1fr;
  grid-template-rows: auto;
  column-gap: 8px;
}

.order-info-store-logo {
  grid-area: store-logo;
}

.order-info-store-name {
  grid-area: store-name;
}

.order-info-order-number {
  grid-area: order-number;
}

.nav-bar-actions {
  display: flex;
  justify-content: flex-end;
  gap: @space-16;
  align-items: center;
}

.marketplace-icon {
  height: 24px;
  width: 40px;
  object-fit: contain;
}

@media only screen and (max-width: 900px) {
  .order-details-order-info-section {
    /* disabling because it's much more readable on 2 lines */
    /* stylelint-disable-next-line declaration-colon-space-after*/
    grid-template:
      'store-logo store-name'
      'store-logo order-number';
    grid-template-columns: 40px 1fr;
    grid-template-rows: auto auto;
    column-gap: 8px;
  }
}

.navigation-container {
  display: flex;
  gap: @space-16;
  align-items: center;
}

.customize-toggle-container {
  display: flex;
  gap: @space-8;
  align-items: center;
}

.divider {
  height: 32px;
  border-right: solid 1px var(--default--border-color--1);
}

.header {
  gap: @space-8;
  border: solid 1px var(--default--border-color--1);
  border-radius: 4px;
  padding: @space-0 3px @space-0 @space-12;

  .header-button {
    color: var(--default--text-color--17);
    cursor: pointer;
    height: 32px;
    text-align: center;
    max-width: 120px;
    display: flex;
    gap: @space-8;
    align-items: center;

    > svg {
      color: var(--default--text-color--18);
      height: 16px;
      width: 16px;
    }
  }

  &:hover {
    background-color: var(--order-details-canvas--header-buttons--focus--background-color);
    border-radius: 4px;

    svg,
    .button-name,
    .button-name .caret > svg {
      color: var(--order-details-canvas--header-buttons--focus--text-color);
    }
  }

  &:active {
    border-radius: 4px;
    background-color: var(--order-details-canvas--header-buttons--active--background-color);

    svg,
    .button-name,
    .button-name .caret > svg {
      color: var(--order-details-canvas--header-buttons--active--text-color);
    }
  }

  .selected {
    border-radius: 4px;
    background-color: var(--order-details-canvas--header-buttons--selected--background-color);

    svg,
    .button-name,
    .button-name .caret > svg {
      color: var(--order-details-canvas--header-buttons--selected--text-color);
    }
  }

  .final-left {
    margin-right: auto;
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.customize-toggle {
  font-weight: @bold;
}
